import { t } from 'i18next';
import { activityStateEnum, activityTypeEnum } from '../enums';

export const activityStateLabels: Record<number, string> = {
    [activityStateEnum.ENTERED]: 'validationEntered',
    [activityStateEnum.VALIDATED]: 'validationCompleted',
    [activityStateEnum.VALIDATION]: 'validationInProgress',
    [activityStateEnum.REPORTFILLED]: 'reportSubmitted',
    [activityStateEnum.REPORT]: 'reportInProgress',
    [activityStateEnum.PLANNINGSENT]: 'planningSent',
    [activityStateEnum.PLANNING]: 'planningInProgress',
    [activityStateEnum.NEEDSIMPORTED]: 'needsExported',
    [activityStateEnum.NEEDSSENT]: 'needsSent',
    [activityStateEnum.NEEDSFILLED]: 'needsFilled',
    [activityStateEnum.NEEDS]: 'needsInProgress',
};

export const getActivityStateLabel = (state?: number): string => {
    return state !== undefined && activityStateLabels[state] ? t(activityStateLabels[state]) : '';
};

export const activityTypeLabels: Record<number, string> = {
    [activityTypeEnum.OTHER]: 'other',
    [activityTypeEnum.SITE]: 'site',
    [activityTypeEnum.TRUCK]: 'truck',
};

export const getActivityTypeLabel = (type?: number): string => {
    return type !== undefined && activityTypeLabels[type] ? t(activityTypeLabels[type]) : '';
};
